module.exports = __webpack_public_path__ + "img/public_activities_1.19bb0316.png";